import { CATEGORY_MODEL_KEY } from 'models/daos/category/constants'
import { toIntegerFormatterUtil } from 'models/formatters/utils'

const CATEGORY_BEFORE_VALIDATE_HOOK = {
  [CATEGORY_MODEL_KEY.SECTION_ID]: toIntegerFormatterUtil
}

export {
  CATEGORY_BEFORE_VALIDATE_HOOK
}
